;(function () {
  'use strict'

  angular.module('contrast.d3').factory('d3ColorsService', [d3ColorsService])

  function d3ColorsService() {
    return {
      getColorAccessorFromList: getColorAccessorFromList
    }

    function getColorAccessorFromList(colorList) {
      return function (d, i) {
        return colorList[i % colorList.length]
      }
    }
  }
})()
